import moment from "moment";
import React from "react";
import { getCurrencySymbol } from "../../utils/string";
import { classHelper } from "../../utils/stringUtils";
import * as Variable from "../../utils/variables";
import {
	CreditCardIcon,
	HeartIconFilled,
	HeartIconOutline,
	HourglassIcon,
	MoneyOutlineIcon,
	ShieldStarIcon,
} from "../svg/Icons";
import Image from "../UI/Image";
import Alam from "../../../assets/icons/careers/alam.png";
import Arsitektur from "../../../assets/icons/careers/arsitektur.png";
import Bahasa from "../../../assets/icons/careers/bahasa.png";
import Bisnis from "../../../assets/icons/careers/bisnis.png";
import Desain from "../../../assets/icons/careers/desain.png";
import Hewan from "../../../assets/icons/careers/hewan.png";
import Hukum from "../../../assets/icons/careers/hukum.png";
import Kecantikan from "../../../assets/icons/careers/kecantikan.png";
import Komputer from "../../../assets/icons/careers/komputer.png";
import Media from "../../../assets/icons/careers/media.png";
import Medis from "../../../assets/icons/careers/medis.png";
import Mekanis from "../../../assets/icons/careers/mekanis.png";
import Mode from "../../../assets/icons/careers/mode.png";
import Musik from "../../../assets/icons/careers/musik.png";
import Otomotif from "../../../assets/icons/careers/otomotif.png";
import Wisata from "../../../assets/icons/careers/wisata.png";
import "./ListItem.scss";
import { Buildings, GlobeHemisphereWest } from "@phosphor-icons/react";

export const getLocale = (ENV_NAME) => (ENV_NAME === "bhs" ? "id-ID" : "en-US");

export const ListItem = ({ className, isLoading, left, content, right, ...props }) => {
	return isLoading ? (
		<div className={classHelper("card list-item-card", className)}>
			<div className="card-img-left pulsate" />
			<div className="card-center">
				<p className="card-title placeholder-glow">
					<span className="placeholder placeholder-lg col-2"></span>
					<span className="placeholder placeholder-lg col-6"></span>
				</p>
				<p className="card-text placeholder-glow">
					<span className="placeholder col-7"></span>
					<span className="placeholder col-4"></span>
				</p>
			</div>
			<div className="card-right pulsate" />
		</div>
	) : (
		<div className={classHelper("card list-item-card", className)} {...props}>
			<div className="card-img-left">{left}</div>
			<div className="card-center">{content}</div>
			<div className="card-right">{right}</div>
		</div>
	);
};

const COLLEGE_TYPE = {
	government: Variable.STATE_UNIVERSITY_ABBV,
	private: Variable.PRIVATE_UNIVERSITY_ABBV,
};

export const CollegeListCard = ({
	ENV_NAME,
	className,
	data,
	onClickFavorite,
	recentlyviewedcard,
	smallcard,
	...props
}) => {
	return (
        <ListItem
            className={classHelper('campus-list-card', className)}
            left={
                <div className="campus-logo-container">
                    <Image
                        className="campus-logo"
                        src={data?.college_logo_full_path || data?.college_logo}
                        alt="campus"
                    />
                </div>
            }
            content={
                <div className="d-flex">
                    <div className="flex-grow-1 mw-0 me-std">
                        <div className="campus-name">
                            {data?.college_name || data?.name}
                        </div>
                        {!data?.abroad_accreditation ? (
                            <>
								<div className="d-flex show-small-mobile flex-column smaller-text">
								<div className="d-flex">
								<ShieldStarIcon
                                    className="me-xs"
                                    width="2rem"
                                    height="2rem"
                                    stroke="#FEAF43"
                                />
                                <div className="d-flex align-items-center">
                                    <span className="text-label-dark-gray-2 me-xs">
                                        {Variable.ACCREDITATION[ENV_NAME]}
                                    </span>
                                    <strong className="text-label-dark-gray-2">
                                        {data?.abroad_accreditation ||
                                            data?.college_accreditation ||
                                            '-'}
                                    </strong>
                                </div>
								</div>
                                {!!data?.minimum_fees && <div className="d-flex">
									{/* <div className="vertical-divider mx-xs" /> */}
                                <CreditCardIcon
                                    className="me-xs"
                                    width="2rem"
                                    height="2rem"
                                    stroke="#FEAF43"
                                />
                                <div className="d-flex align-items-center">
                                    <span className="text-label-dark-gray-2 me-xs">
                                        {Variable.START[ENV_NAME]}
                                    </span>
                                    <strong className="text-label-dark-gray-2">
                                        {`${getCurrencySymbol(
                                            data?.fees_currency || 'IDR',
                                            getLocale(ENV_NAME)
                                        )}${
                                            !isNaN(data?.minimum_fees)
                                                ? data?.minimum_fees?.toLocaleString(
                                                      getLocale(ENV_NAME)
                                                  ) || '-'
                                                : data?.minimum_fees || '-'
                                        }`}
                                        /
                                    </strong>
                                    <span className="text-label-dark-gray-2">
                                        {Variable.SMT[ENV_NAME]}
                                    </span>
                                </div>
								</div>
								}
                            </div>
							<div className="d-flex show-small-desktop align-items-center smaller-text">
							<ShieldStarIcon
								className="me-xs"
								width="1.6rem"
								height="1.6rem"
								stroke="#FEAF43"
							/>
							<div className="d-flex align-items-center">
								<span className="text-label-dark-gray-2 me-xs">
									{Variable.ACCREDITATION[ENV_NAME]}
								</span>
								<strong className="text-label-dark-gray-2">
									{data?.abroad_accreditation ||
										data?.college_accreditation ||
										'-'}
								</strong>
							</div>	
							{!!data?.minimum_fees && <div className="d-flex">
							<div className="vertical-divider mx-xs" />
							<CreditCardIcon
								className="me-xs"
								width="2rem"
								height="2rem"
								stroke="#FEAF43"
							/>
								<span className="text-label-dark-gray-2 me-xs">
									{Variable.START[ENV_NAME]}
								</span>
								<strong className="text-label-dark-gray-2">
									{`${getCurrencySymbol(
										data?.fees_currency || 'IDR',
										getLocale(ENV_NAME)
									)}${
										!isNaN(data?.minimum_fees)
											? data?.minimum_fees?.toLocaleString(
												  getLocale(ENV_NAME)
											  ) || '-'
											: data?.minimum_fees || '-'
									}`}
									/
								</strong>
								<span className="text-label-dark-gray-2">
									{Variable.SMT[ENV_NAME]}
								</span>
							</div>
							}
						</div>
							</>
                        ) : (
                            <div className="d-flex align-items-center smaller-text">
								<GlobeHemisphereWest size={20} color="#FEAF43" className="me-xs"/>
                                <div className="d-flex align-items-center">
                                    <p className="mb-0 text-label-dark-gray-2">
										{data?.oldest_college_location?.country.split(',')[0] || "-"}
                                    </p>
                                </div>

                                <div className="vertical-divider mx-xs" />

                                <div className="d-flex align-items-center">
								<Buildings size={20} color="#FEAF43" className="me-xs"/>
                                <div className="d-flex align-items-center">
                                    <p className="mb-0 text-label-dark-gray-2">
										{data?.oldest_college_location?.city || "-"}
                                    </p>
                                </div>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="campus-type">
                        {COLLEGE_TYPE?.[data?.college_type?.toLowerCase()]?.[
                            ENV_NAME
                        ] || data?.college_type}
                    </div>
                </div>
            }
            right={
                <button
                    className="favorite btn"
                    onClick={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        onClickFavorite && onClickFavorite()
                    }}
                >
                    <HeartIconFilled
                        className={
                            data?.is_favourite || data?.is_fav
                                ? 'icon-standby'
                                : 'icon-hover'
                        }
                        width="2.4rem"
                        height="2.4rem"
                        fill="#F24822"
                    />
                    <HeartIconOutline
                        className={
                            data?.is_favourite || data?.is_fav
                                ? 'icon-hover'
                                : 'icon-standby'
                        }
                        width="2.4rem"
                        height="2.4rem"
                        stroke="#F24822"
                    />
                </button>
            }
            {...props}
        />
    )
};

export const MajorListCard = ({
	ENV_NAME,
	className,
	data,
	onClickFavorite,
	recentlyviewedcard,
	smallcard,
	hideFavorite,
	...props
}) => {
	return (
		<ListItem
			className={classHelper("major-list-card", className)}
			left={
				<div className="major-logo-container">
					<Image className="major-logo" src={data?.major_icon_full_path || data?.major_icon} alt="major" />
				</div>
			}
			content={
				<div className="d-flex">
					<div className="flex-grow-1 mw-0 me-std">
						<div className="major-name">{data?.major_name}</div>
						<div className="d-flex align-items-center smaller-text">
							<div className="font-weight-medium">{data?.college?.name}</div>
							{data && !!data.tuition_fee_per_semester && <>
							<div className="vertical-divider mx-xs" />
								<span className="font-weight-semibold text-nowrap">{`${getCurrencySymbol(
								data?.fees_currency || "IDR",
								getLocale(ENV_NAME)
								)}${ Number(data?.tuition_fee_per_semester || 0)?.toLocaleString(getLocale(ENV_NAME)) || "-"} / ${Variable.SMT[ENV_NAME]}`}</span>
							</>}
						</div>
					</div>
					<span className="major-accreditation">
						{`${Variable.ACCREDITATION[ENV_NAME]} `}
						<strong>{data?.abroad_accreditation || data?.major_accreditation}</strong>
					</span>
				</div>
			}
			right={
				<button
					className="favorite btn"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onClickFavorite && onClickFavorite();
					}}
				>
					<HeartIconFilled
						className={data?.is_favourite || data?.is_fav ? "icon-standby" : "icon-hover"}
						width="2.4rem"
						height="2.4rem"
						fill="#F24822"
					/>
					<HeartIconOutline
						className={data?.is_favourite || data?.is_fav ? "icon-hover" : "icon-standby"}
						width="2.4rem"
						height="2.4rem"
						stroke="#F24822"
					/>
				</button>
			}
			{...props}
		/>
	);
};

const sectorImage = {
	"Hukum - Politik - Pegawai Negeri": Alam,
	"Media - Hiburan": Arsitektur,
	"Musik - Hubungan Acara": Bahasa,
	"Desain - Fotografi - Seni": Bisnis,
	Mode: Desain,
	"Wisata - Hotel - Bisnis Perjalanan - Pernikahan": Hewan,
	"Bisnis - Keuangan - Real Estate": Hukum,
	"Bahasa - Hubungan Internasional": Kecantikan,
	"Medis - Kedokteran - Keperawatan": Komputer,
	"Kecantikan - Tata Rias - Estetika": Media,
	"Game - Komputer - Web": Medis,
	"Lingkungan - Alam - Bio": Mekanis,
	"Hewan - Tumbuhan": Mode,
	"Mekanis - Listrik - Elektronik - Kimia": Musik,
	"Otomotif - Penerbangan - Ruang Angkasa": Otomotif,
	"Arsitektur - Teknik sipil - Interior": Wisata,
};

export const CareerListCard = ({ ENV_NAME, className, data, onClickFavorite, smallcard, ...props }) => {
	return (
		<ListItem
			className={classHelper("career-list-card", className)}
			left={
				<div className="career-logo-container">
					<Image
						className="career-logo"
						src={data?.career_icon || data?.career_icon_path || sectorImage?.[data?.sector]}
						alt="career"
					/>
				</div>
			}
			content={
				<div className="d-flex">
					<div className="flex-grow-1 mw-0 me-std">
						<div className="career-name">{data?.career_name}</div>
						<div className="d-flex align-items-center smaller-text">
							<MoneyOutlineIcon className="me-xs" width="1.6rem" height="1.6rem" stroke="#204F8D" />
							<div className="font-weight-semibold">{data?.career_starting_salary}</div>
						</div>
					</div>
				</div>
			}
			right={
				<button
					className="favorite btn"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onClickFavorite && onClickFavorite();
					}}
				>
					<HeartIconFilled
						className={data?.is_favourite ? "icon-standby" : "icon-hover"}
						width="2.4rem"
						height="2.4rem"
						fill="#F24822"
					/>
					<HeartIconOutline
						className={data?.is_favourite ? "icon-hover" : "icon-standby"}
						width="2.4rem"
						height="2.4rem"
						stroke="#F24822"
					/>
				</button>
			}
			{...props}
		/>
	);
};

const SCHOLARSHIP_GIVER = {
	government: Variable.GOVERNMENT,
	college: Variable.COLLEGE,
	private: Variable.ORGANIZATION,
	international: Variable.INTERNATIONAL,
};

export const ScholarshipListCard = ({ ENV_NAME, className, data, onClickFavorite, smallcard, ...props }) => {
	return (
		<ListItem
			className={classHelper("scholarship-list-card", className)}
			left={
				<div className="scholarship-logo-container">
					<Image className="scholarship-logo" src={data?.scholarship_icon} alt="scholarship" />
				</div>
			}
			content={
				<div className="d-flex">
					<div className="flex-grow-1 mw-0 me-std">
						<div className="scholarship-name">{data?.title}</div>
						<div className="d-flex align-items-center smaller-text">
							<HourglassIcon className="me-xs" width="2rem" height="2rem" stroke="#FEAF43" />
							<div className="d-flex align-items-center">
								<span className="text-label-dark-gray-2 me-xs">{Variable.UNTIL[ENV_NAME]}</span>
								<strong className="text-label-dark-gray-2">
									{data?.registration_period ? moment(data?.registration_period).format("ll") : "-"}
								</strong>
							</div>
						</div>
					</div>
					<div className="scholarship-type">
						{SCHOLARSHIP_GIVER?.[data?.scholarship_giver]?.[ENV_NAME] || data?.scholarship_giver}
					</div>
				</div>
			}
			right={
				<button
					className="favorite btn"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onClickFavorite && onClickFavorite();
					}}
				>
					<HeartIconFilled
						className={data?.is_favourite ? "icon-standby" : "icon-hover"}
						width="2.4rem"
						height="2.4rem"
						fill="#F24822"
					/>
					<HeartIconOutline
						className={data?.is_favourite ? "icon-hover" : "icon-standby"}
						width="2.4rem"
						height="2.4rem"
						stroke="#F24822"
					/>
				</button>
			}
			{...props}
		/>
	);
};

export default ListItem;
